/**
 * Keeps `properties[_fulfillment_state]` aligned with the selected variant
 * on non-PDP product forms (featured, quick view) where Liquid only renders initial values.
 */
(function () {
    'use strict';

    var wired_forms = new WeakSet();
    var poll_entries = [];
    var poll_timer = null;

    function line_prop_input(form, underscored_key) {
        var n = 'properties[' + underscored_key + ']';
        var el = form.elements.namedItem(n);
        if (el && el.nodeName === 'INPUT') {
            return el;
        }
        if (el && el.length && el[0] && el[0].nodeName === 'INPUT') {
            return el[0];
        }
        return null;
    }

    function apply_orderability_view(form, ob) {
        if (!form || !ob) {
            return;
        }
        function set_line_prop(key, value) {
            var inp = line_prop_input(form, key);
            if (inp) {
                inp.value = value;
            }
        }
        if (ob.fulfillment_state) {
            set_line_prop('_fulfillment_state', ob.fulfillment_state);
        }
    }

    function parse_map(script_el) {
        try {
            return JSON.parse(script_el.textContent.trim());
        } catch (e) {
            return null;
        }
    }

    function wire_form(form, map) {
        if (!form || !map || wired_forms.has(form)) {
            return;
        }
        wired_forms.add(form);

        function sync_from_id() {
            var id_input = form.querySelector('input[name="id"]');
            var vid = id_input && String(id_input.value);
            if (!vid || !Object.prototype.hasOwnProperty.call(map, vid)) {
                return;
            }
            apply_orderability_view(form, map[vid]);
        }

        form.addEventListener(
            'change',
            function (ev) {
                if (ev.target && ev.target.name === 'id') {
                    sync_from_id();
                }
            },
            true
        );
        form.addEventListener('submit', sync_from_id, true);

        var product_id = form.getAttribute('data-product-id');
        if (product_id && window.MinimogEvents && typeof window.MinimogEvents.subscribe === 'function') {
            window.MinimogEvents.subscribe(String(product_id) + '__VARIANT_CHANGE', function (variant) {
                if (variant && variant.id != null) {
                    var vid = String(variant.id);
                    if (Object.prototype.hasOwnProperty.call(map, vid)) {
                        apply_orderability_view(form, map[vid]);
                    }
                }
            });
        }

        var id_input = form.querySelector('input[name="id"]');
        if (id_input) {
            poll_entries.push({ form: form, inp: id_input, last: String(id_input.value), sync: sync_from_id });
        }

        sync_from_id();
    }

    function discover_and_wire() {
        document.querySelectorAll('script[data-hfc-orderability-by-variant]').forEach(function (script_el) {
            var form = script_el.closest('form[data-type="add-to-cart-form"]');
            if (!form) {
                return;
            }
            var map = parse_map(script_el);
            if (map) {
                wire_form(form, map);
            }
        });
    }

    function start_poll() {
        if (poll_timer != null) {
            return;
        }
        poll_timer = window.setInterval(function () {
            poll_entries.forEach(function (entry) {
                if (!entry.form.isConnected) {
                    return;
                }
                var v = String(entry.inp.value);
                if (v !== entry.last) {
                    entry.last = v;
                    entry.sync();
                }
            });
        }, 400);
    }

    function init() {
        discover_and_wire();
        if (poll_entries.length) {
            start_poll();
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    var mo_scheduled = false;
    var mo = new MutationObserver(function () {
        if (mo_scheduled) {
            return;
        }
        mo_scheduled = true;
        requestAnimationFrame(function () {
            mo_scheduled = false;
            discover_and_wire();
            if (poll_entries.length && poll_timer == null) {
                start_poll();
            }
        });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
})();
